import { className } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

const CurrentPeriod = () => {
  return (
    <div className="p-4">
      <Panel title="Next period">
        <div className="grid grid-cols-2 gap-x-8">
          <div className="col-span-2 text-sm text-theme-gray-500 dark:text-theme-gray-400 pb-2">
            Next payment (USD$ 60.00) is due on 2019-01-01.
          </div>
          <div className="col-span-2 text-sm text-theme-gray-500 dark:text-theme-gray-400 pb-2">
            Pays for service until 2019-02-01 (one month).
          </div>
          <div className="col-span-2 pb-6">
            <button
              className={`${className} float-start`}
              type="submit"
              onClick={() => console.log('click button')}
            >
              View invoice
            </button>
          </div>
        </div>
      </Panel>
    </div>
  )
}

export default CurrentPeriod
